import React, {useEffect, useState} from 'react';
import styles from './styles.module.scss';
import {Col, Form, Input, Radio, Spin} from 'antd';
import {AccountInput, ContinueButton, HeadingAnimationWrapper, NextImgStyled, StepFourFormContainer, StyledFormItem, StyledRadioGroup, StyledForm} from './helpers';
import Image from 'next/image';
import {LoadingOutlined} from '@ant-design/icons';
import {useStore} from '@/store/root-store';
import {linkgraphDomains} from '@/utils/router';
import {getDomain, getSingleUrlParam} from '@/utils/url';
import {LogoWrapper} from '../components/logo-wrapper/logoWrapper';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowLeft} from '@fortawesome/pro-solid-svg-icons';
import {RegisterRating} from '../rating';
import {metaClickEvents} from '@/utils/functions';

const StepFour = ({setStepData, stepData, loading, onRegister = null, previousStep = 'stepTwo', buttonText = 'Next'}) => {
  const currentDomain = getDomain(window.location.hostname);
  const isWhiteLabelDomain = !linkgraphDomains.includes(currentDomain);
  const {settings: {customer: {profile: {brandColor, logo, signUpLogo}}}} = useStore('');
  const invitationToken = getSingleUrlParam('invitation_token');
  const [showError, setShowError] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    const obj = {...stepData.data,
      category: stepData?.data?.category,
      clients: stepData?.data?.clients || '1-10',
      role: stepData?.data?.role || 'Owner/Founder',
      companySize: stepData?.data?.companySize || '1-10',
      companyName: stepData?.data?.companyName || '',
      customDesignationValue: stepData?.data?.customDesignationValue,
    };
    setStepData({step: stepData?.step, data: obj});
  }, [stepData?.step]);

  const options = [
    {label: 'Agency', value: 'Agency'},
    {label: 'Brand', value: 'Brand'},
  ];

  const clientsOptions = [
    {label: '1-10', value: '1-10'},
    {label: '11-50', value: '11-50'},
    {label: '51-100', value: '51-100'},
    {label: '101+', value: '101+'},
  ];

  const titleOptions = [
    {label: 'Owner/Founder', value: 'Owner/Founder'},
    {label: 'Executive', value: 'Executive'},
    {label: 'Director', value: 'Director'},
    {label: 'Manager', value: 'Manager'},
    {label: 'Specialist', value: 'Specialist'},
    {label: 'Other', value: 'other'},
  ];

  const businessSizeOptions = [
    {label: '1-10 employees', value: '1-10'},
    {label: '10-50 employees', value: '10-50'},
    {label: '50-100 employees', value: '50-100'},
    {label: '100+ employees', value: '100+'},
  ];

  const accountTypeMapping = {
    Agency: {
      secRowOptions: {
        options: clientsOptions,
        title: 'How many clients does your agency manage?',
        key: 'clients',
      },
    },
    Brand: {
      secRowOptions: {
        options: businessSizeOptions,
        title: 'What’s the size of your business?',
        key: 'companySize',
      },
    },
  };

  const onClickNext = () => {
    try {
      if (stepData?.data?.role === 'other' && !stepData?.data?.customDesignationValue?.length) {
        setShowError(true);
        return;
      }
      const data = {
        category: stepData?.data?.category,
        clients: stepData?.data?.clients,
        role: stepData?.data?.role,
        companySize: stepData?.data?.companySize,
        companyName: stepData?.data?.companyName,
        customDesignationValue: stepData?.data?.customDesignationValue,
      };
      metaClickEvents('click_register_step_4', {step: 'step 4', data: data});
      if (onRegister) {
        onRegister();
      } else {
        setStepData({step: 'stepFour', data: stepData?.data});
      }
    } catch (error) {
      return false;
    }
  };

  return (
    <>
      <div className={styles.changeBg}>
        {(isWhiteLabelDomain && brandColor) && (
          <>
            <div className={styles.bgBack}></div>
            <div className={styles.bgFront} style={{'--brand-color': brandColor} as any}></div>
          </>
        )}
        <div className={styles.formContainer}>
          <div
            style={{height: '22px'}}
          />
          <LogoWrapper>
            <NextImgStyled className={invitationToken && styles.invitationLogo} src={isWhiteLabelDomain ? (signUpLogo ?? logo) : '/img/searchatlasLogo.svg'} />
          </LogoWrapper>
          {invitationToken ? <div className={styles.invitationTitle}>Accept your Invitation</div> : <div className={styles.descriptionContainer}>
            <div className={styles.container}>
              <HeadingAnimationWrapper>
                <div style={{padding: '0 20px'}}>
                  <p className={styles.text}>One more step!</p>
                </div>
              </HeadingAnimationWrapper>
              <div id='console' className='console-underscore'></div>
            </div>
            <div className={styles.descriptionWrapper}>
              <div className={styles.stepFourDescription} style={{maxWidth: 470}}>Answer a few quick questions to tailor features and insights just for you. It only takes a minute!</div>
            </div>
          </div>}
          <StepFourFormContainer style={{width: 490, maxWidth: '35vw', minWidth: 460}} brandColor={(isWhiteLabelDomain && brandColor) ? brandColor : ''}>
            <StyledForm initialValues={{companyName: stepData?.data?.companyName}} className={styles.form} form={form} onFinish={() => onClickNext()}>
              <div className={styles.backButton}>
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  color='#121212'
                  fontSize={20}
                  style={{opacity: 0.5, cursor: 'pointer'}}
                  onClick={() => setStepData({step: previousStep, data: {...stepData.data}})}
                />
              </div>
              <div className='content-container'>
                <div className={classNames(styles.formTitlestepFour)}>
                  <p style={{marginBottom: 'unset', width: '100%', lineHeight: '22px'}}>Company Name <span style={{color: '#FF1A1A'}}>*</span></p>
                </div>
                <Col span={24} style={{marginTop: 10, marginBottom: 16}}>
                  <StyledFormItem
                    name='companyName'
                    rules={[
                      {
                        required: true,
                        message: 'Please enter your company name',
                      },
                      {
                        whitespace: true,
                        message: 'Only Empty Spaces are not allowed',
                      },
                    ]}
                    style={{marginBottom: 20}}
                    className='companyFormItem'
                  >
                    <AccountInput
                      type='text'
                      placeholder={'Your company name'}
                      onChange={e => {
                        const value = e.target.value;

                        setStepData({
                          step: stepData?.step,
                          data: {
                            ...stepData.data,
                            companyName: value,
                          },
                        });
                      }}
                    />
                  </StyledFormItem>
                </Col>
                <div className={classNames(styles.formTitlestepFour)} style={{margin: 0}}>
                  <p style={{marginBottom: 'unset', width: '100%', lineHeight: '22px'}}>Are you signing up as an agency or a brand? <span style={{color: '#FF1A1A'}}>*</span></p>
                </div>
                <Col span={24}>
                  <StyledFormItem
                    name='category'
                    initialValue={stepData?.data?.category}
                    rules={[
                      {
                        required: true,
                        message: 'Please select an option',
                      },
                    ]}
                    style={{marginBottom: 20}}
                  >
                    <StyledRadioGroup
                      onChange={e => {
                        const category = e.target.value;
                        const accountMapping = accountTypeMapping[category]?.secRowOptions?.options[0]?.value;

                        setStepData({
                          step: stepData?.step,
                          data: {
                            ...stepData.data,
                            category,
                            [category === 'Agency' ? 'clients' : 'companySize']: accountMapping,
                          },
                        });
                      }}
                      value={stepData.data.category}
                      options={options}
                    />
                  </StyledFormItem>
                </Col>
                {stepData?.data?.category && <>
                  <div style={{marginTop: '30px'}} className={classNames(styles.formTitlestepFour)}>
                    <p style={{marginBottom: 'unset', width: '100%', lineHeight: '22px'}}>{accountTypeMapping[stepData.data.category]?.secRowOptions?.title} <span style={{color: '#FF1A1A'}}>*</span></p>
                  </div>
                  <Col span={24}>
                    <StyledFormItem
                      style={{marginBottom: '5px'}}
                      positionLeft
                    >
                      <StyledRadioGroup
                        onChange={e => {
                          const obj = {};
                          if (stepData?.data?.category === 'Agency') {
                            obj['clients'] = e.target.value;
                            const optionIndex = clientsOptions?.map(option => option?.value)?.indexOf(e.target.value);
                            obj['companySize'] = businessSizeOptions[optionIndex]?.value;
                          } else {
                            obj['companySize'] = e.target.value;
                            const optionIndex = businessSizeOptions?.map(option => option?.value)?.indexOf(e.target.value);
                            obj['clients'] = clientsOptions[optionIndex]?.value;
                          }
                          setStepData({step: stepData?.step, data: {...stepData?.data, ...obj}});
                        }}
                        value={stepData?.data[accountTypeMapping[stepData.data.category]?.secRowOptions?.key]}
                        options={accountTypeMapping[stepData?.data?.category]?.secRowOptions?.options}
                      />
                    </StyledFormItem>
                  </Col>
                </>}
                <div style={{marginTop: '30px'}} className={classNames(styles.formTitlestepFour)}>
                  <p style={{marginBottom: 'unset', width: '100%', lineHeight: '22px'}}>What’s your title? <span style={{color: '#FF1A1A'}}>*</span></p>
                </div>
                <Col span={24}>
                  <StyledRadioGroup
                    onChange={e => {
                      const obj = {role: e.target.value, customDesignationValue: ''};
                      setStepData({step: stepData?.step, data: {...stepData.data, ...obj}});
                      setShowError(false);
                    }}
                    value={stepData.data.role}
                    style={{textAlign: 'left'}}
                  >
                    {titleOptions?.map(item => {
                      return (
                        <Radio key={item?.value} className={item?.value === 'other' ? 'remove-bg' : ''} value={item?.value}>
                          {item?.value === 'other' ? <> <div className={styles.otherSection}>
                            <div>{item?.label}:</div> <div><Input value={stepData?.data?.customDesignationValue} className='other-input' onChange={e => {
                              if (e.target.value?.trim()?.length || stepData?.data?.role !== 'other') {
                                setShowError(false);
                              } else {
                                setShowError(true);
                              }
                              setStepData({step: stepData?.step, data: {...stepData.data, customDesignationValue: e.target.value}});
                            }} />
                            </div>
                          </div>
                          {showError && <p className={styles.errorMessage}>This field is required</p>}
                          </>:
                            item?.label
                          }
                        </Radio>
                      );
                    })}
                  </StyledRadioGroup>
                </Col>
                <Col>
                  <ContinueButton htmlType='submit' brandColor={(isWhiteLabelDomain && brandColor) ? brandColor : ''} style={{marginBottom: '0px', marginTop: '18px'}} disabled={loading} loadingStyle={loading ? 'opacity: 0.7;' : ''}>
                    <div>{buttonText}</div>
                    {loading ? <Spin indicator={<LoadingOutlined style={{color: '#ffff', fontSize: '20px'}} spin />} /> : <Image alt='searchAtlasIcon' src='/img/registerBg/searchAtlasIcon.svg' width={16} height={16} />}
                  </ContinueButton>
                </Col>
                <Col style={{marginTop: '30px'}}>
                  <div className={styles.footerContainer}>
                    <RegisterRating showLowerSection value={5} marginRight={'15px'}/>
                    <img style={{width: '70%', height: 28}} src={'/img/registerBg/footer-icons-2.svg'} />
                  </div>
                </Col>
              </div>
            </StyledForm>
          </StepFourFormContainer>
        </div>
      </div>
    </>
  );
};

export default StepFour;
